import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";

function CommonDataGrid({
  rows = [],
  columns = [],
  rowCount = 0,
  loading = false,
  paginationModel,
  onPaginationModelChange,
  sortModel,
  onSortModelChange,
  getRowId = row => row.id,
  initialSortField = "id",
  initialSortOrder = "asc", 
  getRowClassName
}) {
  return (
    <DataGrid
      rows={rows}
      columns={columns}
      rowCount={rowCount}
      loading={loading}
      paginationMode="server"
      sortingMode="server"
      paginationModel={paginationModel}
      onPaginationModelChange={onPaginationModelChange}
      sortModel={sortModel}
      onSortModelChange={onSortModelChange}
      getRowId={getRowId}
      disableRowSelectionOnClick
      disableColumnMenu
      getRowClassName={getRowClassName}     
      sortingOrder={["desc", "asc"]}      
      initialState={{
        sorting: {
          sortModel: [{ field: initialSortField, sort: initialSortOrder }],
        },
      }}
    />
  );
}

export default CommonDataGrid;

CommonDataGrid.propTypes = {
  rows: PropTypes.any,
  columns: PropTypes.any,
  rowCount: PropTypes.any,
  loading: PropTypes.any,
  paginationModel: PropTypes.any,
  onPaginationModelChange: PropTypes.any,
  sortModel: PropTypes.any,
  onSortModelChange: PropTypes.any,
  getRowId: PropTypes.any,
  initialSortField: PropTypes.any,
  initialSortOrder: PropTypes.any,
};
